@if (isAddClicked) {
  <app-area-setup
    (close)="toggleModal($event)"
    (reload)="reloadTable(currentPage)"
    [selectedArea]="selectedRowId"
  ></app-area-setup>
}
<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row d-flex justify-content-between g-0 m-0">
      <div
        class="col-10 d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-3"
      >
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <app-search
          placeholder="{{ 'SETTINGS_SEARCHBYNAME&CODE' | translate }}"
          (searchChange)="searchChange($event)"
        ></app-search>
      </div>
      @if (
        authService.isAuthorized([
          PermissionsEnum.Settings_crud_area_modify,
        ])
      ) {
        <div
          class="col-2 d-flex align-items-center justify-content-end g-0 m-0 mt-3 mb-3 me-4 add"
          (click)="toggleModal()"
        >
          <span
            >{{ "ADD" | translate }} {{ "DEVICESETUP_AREA" | translate }}</span
          >
        </div>
      }
    </div>
    <div class="row g-0 m-0 pt-3">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg"  />
                <span>{{ "NAME" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg"  />
                <span>{{ "CODE" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg"  />
                <span>{{ "REGION_NAME" | translate }}</span>
              </div>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of data"
            (click)="
              authService.isAuthorized([
                PermissionsEnum.Settings_crud_area_modify,
              ])
                ? handleRowClick(row)
                : null
            "
          >
            <td></td>
            <td>
              <span>{{ row.name }}</span>
            </td>
            <td>
              <span (click)="clipboardService.copyToClipboard(row.code!, $event)" class="copyable">
                {{ row.code }}
                <span class="copy-tooltip" *ngIf="clipboardService.copiedText === row.code">{{ "COPIED" | translate }}</span>
              </span>
            </td>
            <td>
              <span>{{ row.regionName }}</span>
            </td>
            <td>
              @if (
                authService.isAuthorized([
                  PermissionsEnum.Settings_crud_area_delete,
                ])
              ) {
                <img 
                alt="Delete"
                  src="assets/core/table/delete.svg"
                  (click)="handleDelete()"
                />
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfAreas"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>

<app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="AREA_DELETE"
  (confirm)="confirmDelete(selectedRowId!)" (cancel)="cancelDelete()"></app-confirm-dialog>
